/**
 * ProtectedAdminRoute.js
 * Author: Markus.van.Kempen@gmail.com
 * Date: 2nd Nov 2025
 */

import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';
import LoadingSpinner from './LoadingSpinner';
import '../styles/admin-shared.css';

const ProtectedAdminRoute = ({ children }) => {
    const { isAuthenticated, isLoading, hasAnyRole } = useAuth();

    if (isLoading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh'
            }}>
                <LoadingSpinner size="medium" message="Verifying access..." />
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login?returnUrl=/admin" replace />;
    }

    // Check for admin or super_admin role
    if (!hasAnyRole(['admin', 'super_admin'])) {
        return (
            <div style={{
                padding: '50px',
                textAlign: 'center',
                color: 'var(--color-text-primary)'
            }}>
                <h2>Access Denied</h2>
                <p>You do not have permission to view this page.</p>
                <p>Required role: Administrator</p>
                <button
                    onClick={() => window.location.href = '/'}
                    style={{
                        marginTop: '20px',
                        padding: '10px 20px',
                        background: 'var(--color-primary)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer'
                    }}
                >
                    Return to Home
                </button>
            </div>
        );
    }

    return <div className="admin-shell">{children}</div>;
};

export default ProtectedAdminRoute;
